const isLoggedReducer = (state = false, action) => {
    switch(action.type)
    {
        case 'newBool':
            state = action.bool;
            return state;
        default :
            return state;
    }
}

export default isLoggedReducer;